export default __webpack_public_path__ + "static/media/AboutBannerRocketRecolor.46727762.png";